import type { TrackCategory } from '@/track/track.constants';
import type { AnyProperty } from '@/utilities.types';

type TrackInformation = string | AnyProperty;
type TrackFunction = (
  category: TrackCategory,
  action: string,
  information?: TrackInformation,
  dateRange?: { displayRange: any; investigateRange: any },
) => void;

let trackFunction: TrackFunction = () => undefined;

export function registerTrackFunction(fn: TrackFunction) {
  trackFunction = fn;
}

export function doTrack(
  category: TrackCategory,
  action: string,
  information?: TrackInformation,
  dateRange?: { displayRange: any; investigateRange: any },
) {
  return trackFunction(category, action, information, dateRange);
}
